import { useState } from 'react';
import type { SaveRecovery } from '@/app/services';
import { ImportSaveButton, ResetConfirm } from '@/ui/components/SaveFileActions';
import { useI18n } from '@/ui/i18n/I18nProvider';
import { downloadText, saveFileName } from '@/ui/util/download';
import styles from './ErrorScreen.module.css';

/**
 * The main save and every backup failed their checks (content-schemas §11.3). Never reset silently: the player
 * can download the broken file for support, import an exported save, or start over after typing the phrase.
 */
export function SaveRecoveryScreen({ rawJson, recovery }: { rawJson: string; recovery: SaveRecovery }) {
  const { t } = useI18n();
  const [resetting, setResetting] = useState(false);
  return (
    <div className={styles.screen} role="alert" data-testid="save-recovery">
      <div className={styles.card}>
        <h1 className={styles.title}>{t('system.save_corrupt.title')}</h1>
        <p>{t('system.save_corrupt.body')}</p>
        <div className={styles.stack}>
          <button
            type="button"
            className={styles.button}
            onClick={() => {
              downloadText(saveFileName(new Date(), '-hong'), rawJson);
            }}
          >
            {t('system.save_corrupt.download')}
          </button>
          <ImportSaveButton read={recovery.readSaveFile} apply={recovery.importSave} />
          {resetting ? (
            <ResetConfirm
              body={t('system.save_corrupt.reset_body')}
              onCancel={() => {
                setResetting(false);
              }}
              onConfirm={recovery.reset}
            />
          ) : (
            <button
              type="button"
              className={styles.link}
              onClick={() => {
                setResetting(true);
              }}
            >
              {t('ui.settings.reset')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
